import React from "react";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  element: React.ReactElement;
}

const ProtectedRoute = ({ element }: ProtectedRouteProps) => {
  const location = useLocation();
  const token = localStorage.getItem("access_token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const userString = localStorage.getItem("user") ?? "{}";
  const userObj = JSON.parse(userString);
  const hasOnboarding = userObj.onboardingAccounts?.length;

  if (!hasOnboarding && !location.pathname.includes("/onboarding")) {
    return <Navigate to="/onboarding" replace />;
  }

  return element;
};

export default ProtectedRoute;